export function getSanitizedRUT(input: string) {
  const trimmedRut = input.trim();

  const sanitizedRUT = trimmedRut
    .replace(/^[0K]+/i, "")
    .replace(/[^0-9K]/gi, "")
    .replace(/(?:KK)/i, "K");

  if (sanitizedRUT.length > 1) {
    const rut = sanitizedRUT.slice(0, sanitizedRUT.length - 1).replace(/\D/i, "");
    const dv = sanitizedRUT.slice(-1).toUpperCase();

    return { rut, dv };
  }

  return { rut: sanitizedRUT, dv: "" };
}

export function formatRUT(rut: string) {
  const { rut: cleanRUT, dv } = getSanitizedRUT(rut);

  if (dv) {
    const start = new Intl.NumberFormat("es-CL").format(Number(cleanRUT));

    return `${start}-${dv}`;
  }

  return cleanRUT.toString();
}
